import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import { useTranslate } from '@tolgee/react';
import { PlusIcon } from '../../../../assets/PlusIcon';
import { MinusIcon } from '../../../../assets/MinusIcon';

const BUTTON =
	'w-9 h-9 flex items-center justify-center border-none bg-white p-0 cursor-pointer transition-colors duration-150 hover:bg-track-hover active:bg-track-indigo-soft';

const TrackingZoomControl: React.FC = () => {
	const { t } = useTranslate();
	const map = useMap();
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!ref.current) return;
		L.DomEvent.disableClickPropagation(ref.current);
		L.DomEvent.disableScrollPropagation(ref.current);
	}, []);

	return (
		<div
			ref={ref}
			className="absolute right-4 sm:right-5 bottom-4 sm:bottom-6 z-[600] hidden sm:flex flex-col bg-white border border-solid border-track-line rounded-[10px] overflow-hidden shadow-[0_2px_12px_rgba(31,31,39,0.08)]"
		>
			<button
				type="button"
				aria-label={t('orderTracking.zoomIn', 'Zoom in')}
				className={BUTTON}
				onClick={() => map.zoomIn()}
			>
				<PlusIcon color="#484880" />
			</button>
			<span className="h-px bg-track-line" />
			<button
				type="button"
				aria-label={t('orderTracking.zoomOut', 'Zoom out')}
				className={BUTTON}
				onClick={() => map.zoomOut()}
			>
				<MinusIcon color="#484880" />
			</button>
		</div>
	);
};

export default TrackingZoomControl;
